import { UserDeviceStatus } from '@/types';

export const UserDeviceStatusColorMap = {
    [UserDeviceStatus.CONNECTED]: '#B9F6D1',
    [UserDeviceStatus.OFFLINE]: '#EDC7CD',
};
